import { runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { t } from 'react-switch-lang';
import usersStorage from '../../../pages/Users/usersStorage';
import { requestPost } from '../../../services/real.backend';
import UserModel from '../../../models/UserModel';

export default function saveUsers(data) {
  return requestPost('/api/users/update', { users: data })
    .then((resp) => {
      runInAction(() => {
        usersStorage.currentChanges = {};
        usersStorage.isUserSaveRequestProgress = false;
        usersStorage.loadDataFromServer();
        if (resp[-1]) {
          usersStorage.setCurrentUser(resp[-1].id);
        }
        // const { users } = resp;
        // console.log('USERS:', resp);
        // if (resp) {
        //   Object.keys(resp).map((userID) => {
        //     const index = usersStorage.findUser(userID);
        //     console.log('USER: ', userID, index, resp[userID]);
        //     usersStorage.users.splice(index, 1);
        //     usersStorage.users.push(new UserModel(resp[userID]));
        //   });
        //   usersStorage.users = [...usersStorage.users];
        // }
        toast.success(t('global.saved'));
      });
    })
    .catch((e) => {});
}
